// extracted by mini-css-extract-plugin
export var container = "WidgetCard-module--container--1gVYX";
export var selected = "WidgetCard-module--selected--177Zw";